import React from 'react';
import { Scale } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-legal-900 pt-16 pb-8 border-t border-legal-700" data-id="element-101">
      <div className="container mx-auto px-4" data-id="element-102">
        <div className="flex flex-col items-center text-center mb-12" data-id="element-103">
          <div className="flex items-center gap-2 text-gold-500 mb-6" data-id="element-104">
            <Scale className="w-8 h-8" data-id="element-105" />
            <span className="text-2xl font-serif font-bold tracking-wider text-white" data-id="element-106">
              TRATADO
            </span>
          </div>

          <p className="text-slate-400 max-w-2xl text-sm leading-relaxed mb-8" data-id="element-107">
            Aviso Legal: El material proporcionado en este tratado tiene fines
            educativos, informativos y de referencia para profesionales del
            derecho. La adquisición y uso de estos modelos no constituye
            asesoramiento legal individual ni garantiza resultados específicos
            en litigios. Cada caso debe ser analizado de forma particular por el
            profesional interviniente.
          </p>
        </div>

        <div className="border-t border-legal-800 pt-8 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500" data-id="element-108">
          <p data-id="element-109">
            &copy; 2026 Tratado Amparo de Salud. Todos los derechos reservados.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0" data-id="element-110">
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-111">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-112">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
};